import React from "react";
import "./OurOffices.css";

const offices = [
  {
    id: "coimbatore",
    city: "Coimbatore",
    isHQ: true,
    address: "34/17A, First floor, Ramalingam Nagar 4th Cross Street, Saibaba Colony, Coimbatore – 641 011, Tamil Nadu",
    email: "info@ibots.in",
    phone: "+91 9442717713",
    countryCode: null,
  },
  {
    id: "tirunelveli",
    city: "Tirunelveli",
    isHQ: false,
    address: "RJS Complex, 158/6, KTC Nagar, Tirunelveli – 627002, Tamil Nadu, India",
    email: "info@ibots.in",
    phone: null,
    countryCode: null,
  },
  {
    id: "tiruvannamalai",
    city: "Tiruvannamalai",
    isHQ: false,
    address: "C/O S.Raja, Arasamara Street (Near E.B), Karapattu, Chengam, Tiruvannamalai – 606705, Tamil Nadu",
    email: "info@ibots.in",
    phone: null,
    countryCode: null,
  },
  {
    id: "canada",
    city: "Canada",
    isHQ: false,
    address: "3515 17 Ave SW, Calgary, AB T3E 0B7, Canada",
    email: "info@ibots.in",
    phone: null,
    countryCode: "CA",
  },
];

/* ── Inline SVG skylines ── */
const CoimbatoreSkyline = () => (
  <svg viewBox="0 0 400 160" xmlns="http://www.w3.org/2000/svg" className="oo__skyline">
    <defs>
      <linearGradient id="cbg" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#a8d8f0" />
        <stop offset="100%" stopColor="#4a9fc8" />
      </linearGradient>
      <linearGradient id="cwat" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#3a7fc8" />
        <stop offset="100%" stopColor="#1a4f8a" />
      </linearGradient>
    </defs>
    <rect width="400" height="160" fill="url(#cbg)" />
    {/* Clouds */}
    <ellipse cx="60" cy="30" rx="40" ry="18" fill="white" opacity="0.7" />
    <ellipse cx="90" cy="25" rx="30" ry="14" fill="white" opacity="0.8" />
    <ellipse cx="300" cy="40" rx="35" ry="15" fill="white" opacity="0.6" />
    <ellipse cx="330" cy="35" rx="25" ry="12" fill="white" opacity="0.7" />
    {/* Gopuram / temple tower */}
    <rect x="170" y="55" width="24" height="70" fill="#1a4f8a" />
    <rect x="165" y="65" width="34" height="8" fill="#1a4f8a" />
    <rect x="160" y="75" width="44" height="6" fill="#1a4f8a" />
    <rect x="155" y="83" width="54" height="6" fill="#1a4f8a" />
    <rect x="150" y="91" width="64" height="6" fill="#1a4f8a" />
    <rect x="145" y="99" width="74" height="5" fill="#1a4f8a" />
    <polygon points="182,45 170,58 194,58" fill="#1a4f8a" />
    {/* Buildings */}
    <rect x="60" y="80" width="30" height="45" fill="#1e5a9a" opacity="0.85" />
    <rect x="95" y="95" width="22" height="30" fill="#2567a8" opacity="0.8" />
    <rect x="230" y="70" width="35" height="55" fill="#1e5a9a" opacity="0.85" />
    <rect x="270" y="90" width="25" height="35" fill="#2567a8" opacity="0.8" />
    <rect x="300" y="85" width="40" height="40" fill="#1a4f8a" opacity="0.8" />
    <rect x="20" y="100" width="35" height="25" fill="#2567a8" opacity="0.75" />
    <rect x="345" y="95" width="30" height="30" fill="#2567a8" opacity="0.75" />
    {/* Water reflection */}
    <rect x="0" y="135" width="400" height="25" fill="url(#cwat)" opacity="0.5" />
    <path d="M0,140 Q50,135 100,140 Q150,145 200,140 Q250,135 300,140 Q350,145 400,140 L400,160 L0,160Z" fill="#2a6ab0" opacity="0.4" />
  </svg>
);

const TirunelveliSkyline = () => (
  <svg viewBox="0 0 400 160" xmlns="http://www.w3.org/2000/svg" className="oo__skyline">
    <defs>
      <linearGradient id="tbg" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#0d1f5c" />
        <stop offset="50%" stopColor="#1a3a7a" />
        <stop offset="100%" stopColor="#0a1440" />
      </linearGradient>
    </defs>
    <rect width="400" height="160" fill="url(#tbg)" />
    {/* Stars */}
    {[30,70,120,180,240,290,340,380,50,150,220,310].map((x, i) => (
      <circle key={i} cx={x} cy={10 + (i % 4) * 8} r="1.2" fill="white" opacity="0.8" />
    ))}
    {/* Moon */}
    <circle cx="340" cy="28" r="16" fill="#f0e68c" opacity="0.9" />
    <circle cx="350" cy="22" r="13" fill="#1a3a7a" />
    {/* Temple gopuram - tall */}
    <rect x="175" y="30" width="20" height="100" fill="#0a1440" />
    <rect x="170" y="42" width="30" height="7" fill="#0a1440" />
    <rect x="165" y="51" width="40" height="6" fill="#0a1440" />
    <rect x="160" y="59" width="50" height="6" fill="#0a1440" />
    <rect x="155" y="67" width="60" height="5" fill="#0a1440" />
    <rect x="150" y="74" width="70" height="5" fill="#0a1440" />
    <rect x="145" y="81" width="80" height="5" fill="#0a1440" />
    <polygon points="185,22 173,33 197,33" fill="#0a1440" />
    {/* Smaller temple right */}
    <rect x="280" y="70" width="14" height="60" fill="#0a1440" />
    <rect x="276" y="78" width="22" height="5" fill="#0a1440" />
    <rect x="272" y="85" width="30" height="5" fill="#0a1440" />
    <polygon points="287,64 280,72 294,72" fill="#0a1440" />
    {/* Buildings */}
    <rect x="30" y="85" width="28" height="45" fill="#0f2860" />
    <rect x="65" y="95" width="20" height="35" fill="#0f2860" />
    <rect x="90" y="88" width="32" height="42" fill="#0a1e50" />
    <rect x="228" y="82" width="30" height="48" fill="#0a1e50" />
    <rect x="310" y="90" width="28" height="40" fill="#0f2860" />
    <rect x="345" y="98" width="35" height="32" fill="#0a1e50" />
    {/* Ground */}
    <rect x="0" y="128" width="400" height="32" fill="#060e2a" />
    {/* Water */}
    <path d="M0,140 Q80,134 160,140 Q240,146 320,140 Q360,137 400,140 L400,160 L0,160Z" fill="#0d1f5c" opacity="0.6" />
  </svg>
);

const TiruvannamalaiSkyline = () => (
  <svg viewBox="0 0 400 160" xmlns="http://www.w3.org/2000/svg" className="oo__skyline">
    <defs>
      <linearGradient id="anabg" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#f4a348" />
        <stop offset="50%" stopColor="#e07820" />
        <stop offset="100%" stopColor="#8b3a10" />
      </linearGradient>
    </defs>
    <rect width="400" height="160" fill="url(#anabg)" />
    {/* Sun */}
    <circle cx="200" cy="35" r="28" fill="#ffd54f" opacity="0.95" />
    <circle cx="200" cy="35" r="22" fill="#ffca28" />
    {/* Birds */}
    <path d="M130,25 Q134,20 138,25" stroke="#4a1a00" strokeWidth="1.5" fill="none" />
    <path d="M145,18 Q149,13 153,18" stroke="#4a1a00" strokeWidth="1.5" fill="none" />
    <path d="M260,30 Q264,25 268,30" stroke="#4a1a00" strokeWidth="1.5" fill="none" />
    {/* Arunachala hill / stepped pyramid temple */}
    {/* Main pyramid */}
    <polygon points="200,42 120,125 280,125" fill="#2a1a0a" />
    {/* Stepped layers */}
    <rect x="165" y="65" width="70" height="8" fill="#1a0d04" />
    <rect x="153" y="75" width="94" height="8" fill="#1a0d04" />
    <rect x="141" y="85" width="118" height="8" fill="#1a0d04" />
    <rect x="129" y="95" width="142" height="8" fill="#1a0d04" />
    <rect x="120" y="105" width="160" height="8" fill="#1a0d04" />
    {/* Flagpole */}
    <line x1="200" y1="35" x2="200" y2="42" stroke="#2a1a0a" strokeWidth="2" />
    {/* Side buildings/structures */}
    <rect x="50" y="100" width="30" height="25" fill="#2a1a0a" />
    <rect x="85" y="108" width="20" height="17" fill="#3a2010" />
    <rect x="300" y="100" width="30" height="25" fill="#2a1a0a" />
    <rect x="335" y="108" width="25" height="17" fill="#3a2010" />
    {/* Ground */}
    <rect x="0" y="125" width="400" height="35" fill="#5c2a08" />
    <rect x="0" y="140" width="400" height="20" fill="#3d1a04" />
  </svg>
);

const CanadaSkyline = () => (
  <svg viewBox="0 0 400 160" xmlns="http://www.w3.org/2000/svg" className="oo__skyline">
    <defs>
      <linearGradient id="cabg" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#f5c842" />
        <stop offset="50%" stopColor="#e8a020" />
        <stop offset="100%" stopColor="#a05010" />
      </linearGradient>
    </defs>
    <rect width="400" height="160" fill="url(#cabg)" />
    {/* Sun low on horizon */}
    <circle cx="200" cy="110" r="40" fill="#ffd54f" opacity="0.6" />
    {/* Airplane */}
    <path d="M310,22 L325,18 L320,25 L310,22Z" fill="#3a2000" opacity="0.7" />
    <line x1="310" y1="22" x2="295" y2="26" stroke="#3a2000" strokeWidth="1.5" opacity="0.7" />
    {/* Calgary skyline silhouette */}
    {/* CN-tower-like */}
    <rect x="195" y="50" width="8" height="75" fill="#3a1800" />
    <ellipse cx="199" cy="58" rx="12" ry="6" fill="#3a1800" />
    <rect x="196" y="42" width="6" height="16" fill="#3a1800" />
    {/* Tall buildings */}
    <rect x="50" y="75" width="28" height="50" fill="#3a1800" />
    <rect x="82" y="65" width="22" height="60" fill="#2e1200" />
    <rect x="108" y="80" width="18" height="45" fill="#3a1800" />
    <rect x="130" y="70" width="25" height="55" fill="#2e1200" />
    <rect x="215" y="72" width="30" height="53" fill="#3a1800" />
    <rect x="250" y="80" width="22" height="45" fill="#2e1200" />
    <rect x="276" y="68" width="28" height="57" fill="#3a1800" />
    <rect x="308" y="78" width="20" height="47" fill="#2e1200" />
    <rect x="332" y="72" width="32" height="53" fill="#3a1800" />
    {/* Domed building */}
    <rect x="155" y="88" width="36" height="37" fill="#3a1800" />
    <ellipse cx="173" cy="88" rx="18" ry="10" fill="#2e1200" />
    {/* Ground */}
    <rect x="0" y="124" width="400" height="36" fill="#2a0e00" />
    {/* Reflection */}
    <rect x="0" y="135" width="400" height="25" fill="#8b4010" opacity="0.4" />
  </svg>
);

const skylineMap = {
  coimbatore: <CoimbatoreSkyline />,
  tirunelveli: <TirunelveliSkyline />,
  tiruvannamalai: <TiruvannamalaiSkyline />,
  canada: <CanadaSkyline />,
};

function OfficeCard({ office }) {
  return (
    <div className="oo__card">
      <div className="oo__image-wrap">
        {skylineMap[office.id]}
      </div>
      <div className="oo__body">
        <div className="oo__title-row">
          {office.countryCode ? (
            <span className="oo__country-code">{office.countryCode}</span>
          ) : (
            <span className="oo__icon">🏢</span>
          )}
          <h3 className="oo__city">{office.city}</h3>
          {office.isHQ && <span className="oo__hq-badge">HQ</span>}
        </div>
        <p className="oo__address">{office.address}</p>
        <div className="oo__contacts">
          {office.email && (
            <a href={`mailto:${office.email}`} className="oo__contact oo__contact--email">
              <span className="oo__contact-icon">✉</span>
              {office.email}
            </a>
          )}
          {office.phone && (
            <a href={`tel:${office.phone.replace(/\s/g, "")}`} className="oo__contact oo__contact--phone">
              <span className="oo__contact-icon">📞</span>
              {office.phone}
            </a>
          )}
        </div>
      </div>
    </div>
  );
}

function OurOffices() {
  return (
    <section className="oo__section">
      <div className="oo__header">
        <p className="oo__eyebrow">
          <span className="oo__eyebrow-line" />
          WHERE WE ARE
        </p>
        <h2 className="oo__heading">Our Offices</h2>
      </div>
      <div className="oo__grid">
        {offices.map((office) => (
          <OfficeCard key={office.id} office={office} />
        ))}
      </div>
    </section>
  );
}

export default OurOffices;
